export const orderSelectActivity = (activityArray) => {
  const customOrder = [
"Mantenimiento preventivo",
"Visita Predictiva",
"Mantenimiento correctivo",
"Alistamiento",
"Preinstalación",
"Instalación",
"Asistencia técnica",
"Actualización de software",
"Ajuste de consumibles"
  ];

  const normalize = (str) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  return [...activityArray]
    .map(item => ({
      value: item.value,
      label: item.name,
      name: item.name
    }))
    .sort((a, b) => {
      const indexA = customOrder.findIndex(
        o => normalize(o) === normalize(a.label)
      );
      const indexB = customOrder.findIndex(
        o => normalize(o) === normalize(b.label)
      );

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
};